import { SkeletonHighCard } from 'Presentation/Components/Loading/Skeleton'
import CardCarousel from 'Presentation/Components/CardCarousel'
import { isMobileDevice } from '_metronic/assets/ts/_utils'

const LoadingProductLineSelection: React.FC<{ title: string }> = ({ title }) => {
	return (
		<div className="row gy-5 mb-10">
			<div className="col-12">
				<h1 className="text-kumopack-grey-600 my-4">{title}</h1>
			</div>

			<div className="col-12" style={{ height: !isMobileDevice() ? '60vh' : '100vh' }}>
				<div className="h-100 overflow-hidden">
					<div className="card-body h-100">
						<CardCarousel>
							{[...Array(7)].map((_, idx) => (
								<SkeletonHighCard key={`skeleton-high-card-${idx}`} />
							))}
						</CardCarousel>
					</div>
				</div>
			</div>
		</div>
	)
}

export default LoadingProductLineSelection
